export const emptySectionTexts = {
  NO_VEHICLE_TITLE: 'شما خودرویی ثبت نکرده‌اید!',
  NO_VEHICLE_DESCRIPTION:
    'برای استفاده از خدمات خودرو در نرم افزار شهرزاد، ابتدا مشخصات خودرو یا خودروهای خود را ثبت نمایید.',
  NO_VEHICLE_BUTTON: 'افزودن خودروی جدید',

  NO_ACTIVE_RESERVE_TITLE: 'رزرو فعالی وجود ندارد!',
  NO_ACTIVE_RESERVE_DESCRIPTION:
    'شما برای هیچ خودرویی، برای روزهای آینده، نوبت معاینه فنّی رزرو نکرده اید!',
  NO_ACTIVE_RESERVE_BUTTON: 'رزرو نوبت معاینه فنّی خودرو',

  NO_RESERVE_TITLE: 'رزروی وجود ندارد!',
  NO_RESERVE_DESCRIPTION:
    'شما تا به حال برای خودروی انتخاب شده، نوبت معاینه فنّی رزرو نکرده اید!',
  NO_RESERVE_BUTTON: 'رزرو نوبت معاینه فنّی خودرو',

  TRAFFIC_BOOKING_NO_RESERVE_DESCRIPTION:
    'شما برای خودروی انتخاب شده، رزرو فعالی ندارید.',

  NO_SELECTED_DAY_TITLE: 'یک روز مشخص کنید!',
  NO_SELECTED_DAY_DESCRIPTION:
    'لطفا یکی از تاریخ های مشخص شده در بالا را انتخاب نموده تا ساعت های آزاد برای هر روز را مشاهده کنید.',

  NO_ADDRESS_TITLE: 'هنوز آدرسی وارد نکردی!',
  NO_ADDRESS_DESCRIPTION:
    'برای اینکه بتونی نزدیک ترین تامین کننده رو ببینی، اول باید موقعیت مکانی رو مشخص کنی',
  NO_ADDRESS_BUTTON: 'ایجاد آدرس',

  NO_STORE_TITLE: 'متاسفیم فروشگاهی در نزدیکی شما پیدا نشد!',
  NO_STORE_DESCRIPTION: 'به زودی فروشگاه‌های جدیدی اضافه خواهد شد.',
  NO_STORE_BUTTON: 'تغییر آدرس',

  NO_TRANSACTION_TITLE: 'شما هیچ تراکنشی برای نمایش ندارید.',
  NO_CAMPAIGN_TITLE: 'شما هیچ کوپنی برای نمایش ندارید.',

  NO_ACTIVE_ORDER_TITLE: 'شما سفارشی ثبت نکرده‌اید!',
  NO_PAST_ORDER_TITLE: 'تا کنون سفارشی کامل نشده است!',
  NO_ORDER_BUTTON: 'سفارش جدید',

  NO_HEALTHY_PATH_ORDER_TITLE: 'سفری در حال انجام نیست!',
  NO_HEALTHY_PATH_ORDER_DECRIPTION:
    'برای دریافت دوچرخه یا اسکوتر برقی، به نزدیک‌ترین ایستگاه مراجعه کرده و بارکد روی وسیله را اسکن کنید.',

  NO_CART_TITLE: 'سبد خریدی برای شما موجود نیست!',
  NO_CART_BUTTON: 'خرید محصول',

  NO_HISTORY_TITLE: 'تاریخچه‌ای برای نمایش وجود ندارد.',

  NO_CREDIT_CARD_TITLE: 'شما کارت اعتباری فعالی ندارید.',
  NO_CREDIT_CARD_DESCRIPTON:
    'پس از خرید، کارت اعتباری شما در این بخش نمایش داده میشود.',

  NO_DONE_MISSION_TITLE: 'شما هنوز ماموریتی را کامل نکرده اید!',

  NO_DISCOUNT_CODE_TITLE: 'کد تخفیفی برای شما وجود ندارد!',
  NO_DISCOUNT_CODE_DESCRIPTON:
    'پس از دریافت، کد تخفیف‌های شما در این بخش نمایش داده میشود.',

  NO_DEPOSIT_DESCRIPTION:
    'برای برداشت از کیف پول شهروندی، ما نیاز به اطلاعات حساب بانکی شما داریم.',

  NO_TICKET_TITLE: 'شما تا بحال درخواستی ثبت نکرده‌اید!',
  NO_TICKET_DESCRIPTION:
    'پس از ثبت، لیست درخواست‌های شما در این صفحه نمایش داده می‌شود.',
  NOT_FOUND_TITLE: 'درخواست شما پیدا نشد!',
  NOT_FOUND_DESCRIPTION: 'لطفا دوباره تلاش کنید.',

  NO_ONE_WAY_TICKET_TITLE: 'بلیت تک سفره‌ای برای شما موجود نیست',
  NO_ONE_WAY_TICKET:
    'بعد از خرید، بلیت‌های شما در این صفحه نمایش داده می‌شوند.',

  NO_PRODUCT_TITLE: 'محصولی یافت نشد.',

  FULL_CAPACITY_TITLE: 'ظرفیت مرکز موردنظر تکمیل است.',
  FULL_CAPACITY_DESCRIPTION:
    'برای رزرو معاینه فنی  لطفا مرکز دیگری را انتخاب کنید.',
}

export const confirmModalTexts = {
  CANCEL_RESERVE_TITLE: 'لغو رزرو',
  CANCEL_RESERVE_DESCRIPTION:
    'آیا مطمئن هستید می خواهید رزرو معاینه فنّی برای این روز را حذف کنید؟',
  CANCEL_RESERVE_CONFIRM: 'بله، حذف',

  DELETE_VEHICLE_TITLE: 'حذف خودرو',
  DELETE_VEHICLE_DESCRIPTION:
    'آیا مطمئن هستید می خواهید این خودرو را از فهرست خودروهای خود حذف کنید؟',
  DELETE_VEHICLE_CONFIRM: 'بله، حذف',

  DELETE_CARD_TITLE: 'حذف اتصال کارت به کیف پول',
  DELETE_CARD_DESCRIPTION:
    'آیا از حذف اتصال کارت به شماره سریال 698595 به کیف پول اطمینان دارید؟',
  DELETE_CARD_CONFIRM: 'حذف کارت',

  EXPIRED_QR_TITLE: 'تاریخ انقضا بلیت الکترونیک',
  EXPIRED_QR_DESCRIPTION:
    'بلیت الکترونیک شما منقضی شده است، لطفا برای استفاده مجدد یک بلیت جدید ایجاد نمایید..',
  EXPIRED_QR_CONFIRM: 'ساخت بلیت الکترونیک جدید',

  WALLET_OUT_OF_CHARGE_CONFIRM: 'افزایش موجودی',
  WALLET_OUT_OF_CHARGE_CLOSE: 'بازگشت',

  EXIT_TITLE: 'خروج از حساب',
  EXIT_DESCRIPTION: 'آیا مطمئن هستید می خواهید از حساب کاربری خود خارج شوید؟',
  EXIT_CONFIRM: 'بله، خروج',

  TECHNICAL_VISIT_TITLE: 'رزرو معاینه فنی',
  TECHMICAL_VISIT_DESCRIPTION:
    'به علت عدم داشتن معاینه فنی، امکان رزرو طرح ترافیک برای شما وجود ندارد.',
  TECHNICAL_VISIT_CONFIRM: 'رزرو معاینه فنی',

  DELETE_ADDRESS_TITLE: 'حذف آدرس',
  DELETE_ADDRESS_DESCRIPTION:
    'آیا مطمئن هستید می خواهید آدرس را از فهرست آدرس ها پاک کنید؟',
  DELETE_ADDRESS_CONFIRM: 'بله، حذف',

  DELETE_CART_TITLE: 'حذف همه محصولات',
  DELETE_CART_DESCRIPTION:
    'آیا مطمئن هستید می خواهید کل سبد خرید و همه محصولات آن را حذف کنید؟',
  DELETE_CART_CONFIRM: 'بله، حذف',

  CANCEL_OREDR_TITLE: 'لغو سفارش',
  CANCEL_OREDR_DESCRIPTION:
    'آیا مطمئن هستید از خرید خود منصرف شده و می خواهید سفارش را لغو کنید؟',
  CANCEL_OREDR_CONFIRM: 'بله، لغو کن',

  REORDER_TITLE: 'سفارش مجدد',
  REORDER_DESCRIPTION:
    'با تایید سفارش مجدد، اقلام موجود در سبد خرید جایگزین خواهند شد.',

  USER_LEVEL_ONE_ERROR_TITLE: 'نیاز به ارتقاء سطح کاربری',
  USER_LEVEL_ONE_ERROR_DESCRIPTION:
    'برای استفاده از این خدمات در سامانه شهرزاد، باید سطح کاربری خود را ارتقا دهید.',
  USER_LEVEL_ONE_ERROR_CONFIRM: 'ارتقاء به سطح 2',
  USER_LEVEL_ONE_ERROR_CLOSE: 'متوجه شدم',

  REMOVE_BILL_TITLE: 'حذف قبض',
  REMOVE_BILL_DESCRIPTION: 'از حذف قبض خود مطمئن هستید؟',
  REMOVE_BILL_CONFIRM: 'حذف',
  REMOVE_BILL_CLOSE: 'انصراف',

  CONFIRM: 'بله',
  CLOSE: 'خیر',
}

export const loginTexts = {
  PHONE_NUMBER_PAGE_TITLE: 'ورود',
  PHONE_NUMBER_HEADING: 'ورود با رمز یکبار مصرف',
  PHONE_NUMBER_DESCRIPTION:
    'شماره موبایلی که با آن در سامانه شهرزاد و تهران من ثبت نام کرده اید را وارد نمایید.',

  OTP_PAGE_TITLE: 'اعتبارسنجی شماره موبایل',
  OTP_HEADING: 'اعتبارسنجی شماره موبایل',
  OTP_DESCRIPTION:
    'یک پیامک حاوی کد اعتبارسنجی برای شماره موبایل زیر ارسال شده است، لطفا آن را وارد نمایید',
  SUBSTITUTE_OTP:
    'درصورت عدم دریافت پیامک حاوی کد اعتبارسنجی، کد دستوری #۱۱*۱۳۷* را شماره‌گیری نمایید.',

  USERNAME_PAGE_TITLE: 'ورود',
  USERNAME_HEADING: 'ورود به سامانه',
  USERNAME_DESCRIPTION:
    'اطلاعات حساب شما در سامانه شهرزاد و تهران من مشترک هستند.',

  SIGNUP_PAGE_TITLE: 'ثبت نام',
  SIGNUP_HEADING: 'ثبت نام در سامانه',

  SIGNUP_FORM_PAGE_TITLE: 'تکمیل اطلاعات',
  SIGNUP_FORM_HEADING: 'لطفا اطلاعات زیر را تکمیل نمایید',
  SIGNUP_FORM_DESCRIPTION:
    'پیامک کد اعتبارسنجی برای شماره همراه شما ارسال شده است.',

  CHANGE_NUMBER_PAGE_TITLE: 'بازیابی حساب کاربری',
  CHANGE_NUMBER_HEADING: 'تغییر شماره موبایل',
  CHANGE_NUMBER_DESCRIPTION:
    'لطفا شماره موبایل جدید خود را وارد نمایید تا یک پیامک اعتبارسنجی دریافت کنید.',
  SIGNUP_LEGAL_USER_HEADING: 'ثبت نام کاربر حقوقی',
}

export const errorText = {
  OFF_VPN: 'دوست عزیز، لطفا برای دسترسی به شهرزاد فیلترشکن خود را خاموش کنید!',

  NEED_INTERNET: 'دوست عزیز، برای دسترسی به شهرزاد نیاز به اینترنت داری!',

  shahrzad_update:
    'دوست عزیز، شهرزاد در حال به‌روزرسانی است! به زودی برمی‌گردیم',

  TRY_AGAIN_TITLE: 'متاسفانه خطایی رخ داده است!',
  TRY_AGAIN_DESCRIPTION: 'لطفا دوباره تلاش کنید.',

  SERVER_ERROR_TITLE: ' خطای سرور! ',
  SERVER_ERROR_DESCRIPTION: 'لطفاً بعداً تلاش کنید.',

  FORBIDDEN_ACCESS_TITLE: 'دسترسی ممنوع! ',
  FORBIDDEN_ACCESS_DESCRIPTION: 'شما مجاز به دیدن این صفحه نیستید.',

  ILLEGAL_ACCESS_TITLE: 'دسترسی غیرمجاز!',
  ILLEGAL_ACCESS_DESCRIPTION: ' لطفاً وارد شوید یا ثبت‌نام کنید.',

  PAGE_NOT_FOUND_TITLE: 'صفحه‌ای که به دنبالش هستید پیدا نشد!',
  PAGE_NOT_FOUND_DESCRIPTION: 'لطفاً به صفحه اصلی بروید.',

  INVALID_REQUEST_TITLE: 'درخواست نامعتبر است!',
  INVALID_REQUEST_DESCRIPTION: 'لطفاً اطلاعات را با دقت وارد کنید.',

  TIME_OUT_TITLE: ' زمان شما به پایان رسید!',
  TIME_OUT_DESCRIPTION: 'لطفاً بعداً تلاش کنید.',

  NOT_AVAILABLE_TITLE: 'سرویس در دسترس نیست!',
  NOT_AVAILABLE_DESCRIPTION: 'لطفاً بعداً تلاش کنید.',

  WALLET_ERROR_DESCRIPTION:
    'دوست عزیز، باتوجه به مشکلات فنی پیش آمده موجودی کیف پول شما را پیدا نکردیم! برای ادامه فرآیند لطفا دوباره تلاش کنید.',
}
